<template>
    <div>
        <BaseTable
            :naked="true"
            :title="`Impresos${total ? ` (${total})` : ''}`"
            subtitle="Documentos impresos enviados"
            :columns="columns"
            :data="items"
            :loading="loading"
            row-key="id"
            empty-text="Este abonado no tiene impresos registrados"
            customClass="tw:border-none"
            :default-col-width="defaultColWidth"
        >
            <template #cell-fecha_impresion="{ value }">
                {{ formatDate(value) }}
            </template>
            <template #cell-reimpresion="{ value }">
                {{ value ? 'SI' : 'NO' }}
            </template>
        </BaseTable>

        <TablePagination
            :value="page"
            :total="total"
            :per-page="pageSize"
            @input="$emit('paginate', { page: $event })"
        />
    </div>
</template>

<script setup>
    import BaseTable from '@/modules/admin/ui/table/BaseTable.vue'
    import TablePagination from '@/modules/admin/ui/table/TablePagination.vue'

    const props = defineProps({
        items: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        page: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 10
        },
        total: {
            type: Number,
            default: 0
        },
        defaultColWidth: {
            type: String,
            default: '120px'
        }
    })

    const emit = defineEmits(['paginate'])

    const columns = [
        { key: 'fecha_impresion', label: 'Fecha de impresión' },
        { key: 'reimpresion', label: 'Reimpresión' }
    ]

    function formatDate(dateString) {
        if (!dateString) return ''
        const date = new Date(dateString)
        return date.toLocaleDateString('es-AR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        })
    }
</script>
